module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURUdwTK2tra2tra2tra2tra2tra2tra2tra2tra2trdGPNuYAAAAJdFJOUwClHgPwQpDEf8uq4YgAAAAJcEhZcwAAAEgAAABIAEbJaz4AAACeSURBVCjPY2BgYFArmVKmwAAHzIozgWAiQoTV0y2IKczTFa4gEiypODMAKsDk2QCmO52gAuwTITTjdKhApBNMJVRPZgIDKqMSZlhkAYT2hDlA0wFCzzSAClhOwKECwwwMWzDcgeFSuF8moft2Isx+U0h4zJwpDBUwhoQYkhJjcJgaS8KVMBuAsSFCCVQcoQQK6KhkGgOakimoAgxmHgBj0jQej1kHIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/search/search_2.png
// module id = 23
// module chunks = 0